import { IntakeFormData } from './types';

export const INITIAL_FORM: IntakeFormData = {
  generalNotes: '',
  generalNotesLog: [],
  generalNotesLegacy: '',
  referralSource: {
    description: '',
  },
  leadSource: '',
  evidenceStatuses: {
    photos: { status: 'UNCERTAIN', notes: '' },
    witnesses: { status: 'UNCERTAIN', notes: '' },
    policeReport: { status: 'UNCERTAIN', notes: '' },
    ems: { status: 'UNCERTAIN', notes: '' },
    medicalTreatment: { status: 'UNCERTAIN', notes: '' },
    insurance: { status: 'UNCERTAIN', notes: '' },
    lostWages: { status: 'UNCERTAIN', notes: '' },
    financialImpact: { status: 'UNCERTAIN', notes: '' },
  },
  personalInfo: {
    fullName: '',
    dob: '',
    ssnLast4: '',
    phone: '',
    email: '',
    address: '',
    preferredContact: '',
    bestTimeToReach: '',
    preferredLanguage: '',
    driversLicenseNumber: '',
    driversLicenseState: '',
    emergencyContact: {
      name: '',
      phone: '',
      relationship: '',
    },
  },
  incidentInfo: {
    date: '',
    time: '',
    location: '',
    state: '',
    weather: '',
    fromTo: '',
    type: '',
    description: '',
    presentComplaints: '',
    ems: false,
    hospital: '',
    currentlyTreating: false,
    policeReport: false,
    policeDept: '',
    policeReportNumber: '',
    photos: false,
    witnesses: '',
    injuredBodyParts: [],
    painLevel: null,
  },
  insurance: {
    defendants: [],
    pipInsurance: {
      companyName: '',
      policyHolderName: '',
      policyNumber: '',
      claimNumber: '',
      makeModelYear: '',
      licensePlate: '',
      carrier_v2_id: null,
      carrier_division_id: null,
    },
    healthProvider: '',
    healthType: '',
    healthMemberID: '',
    healthGroupID: '',
  },
  medicalWageHistory: {
    treatments: [],
    hasLostWages: false,
    employer: '',
    jobTitle: '',
    hourlyWage: '',
    employmentDuration: '',
    priorMedicalHistory: '',
  },
  legalLifestyle: {
    priorLegalHistory: '',
    lifestyleImpact: '',
    pendingBills: '',
    outOfPocketExpenses: '',
    otherNotes: '',
  },
  companions: [],
};
